import IProjectHeader from "../models/IProjectHeader";
import { makeStyles, Theme, createStyles, Grid } from "@material-ui/core";
import React from "react";
import UserProject from "./UserProject";

interface IUserProjectsGrid {
    userProjects: IProjectHeader[];
    maxToShow: number;
    enableAddUserFunction: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grid: {
            boxshadow: theme.shadows[3]
        }
    })
);

const UserProjectsGrid: React.FC<IUserProjectsGrid> = ({
    userProjects,
    maxToShow,
    enableAddUserFunction
}) => {
    const classes = useStyles();

    return (
        <>
            {userProjects!
                .filter((_, i) => i < maxToShow)
                .map(project => (
                    <Grid
                        key={project.id}
                        item
                        className={classes.grid}
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                    >
                        <UserProject
                            projectHeader={project}
                            enableAddUserFunction={enableAddUserFunction}
                        />
                    </Grid>
                ))}
        </>
    );
};

export default UserProjectsGrid;
